export default "__VITE_ASSET__3db02af0__"